const getSitePropertiesToCreate = (initialProperties, currentProperties) => {
  const propertiesToCreate = [];

  Object.keys(currentProperties).forEach((property) => {
    if (!initialProperties || initialProperties[property] !== undefined) return;

    propertiesToCreate.push({
      name: property,
      value: currentProperties[property],
    });
  });

  return propertiesToCreate;
};

export default getSitePropertiesToCreate;
